import Vue from 'vue';

import wechatSdk from '@/utils/wechatJsSdk.js';





import share from '@/utils/share'

export default function start() {

    Vue.prototype.$wechatPay = wechatSdk; // H5公众号支付




	// Vue.prototype.$share = share; // 挂载全局微信分享 
}